import { createRoot } from 'react-dom/client';
import { GovernanceDashboard } from './governance/GovernanceDashboard';

/**
 * Governance Dashboard Entry Point
 * Initializes React 18 root and mounts the governance dashboard
 */

// Wait for DOM to be ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initGovernance);
} else {
  initGovernance();
}

function initGovernance() {
  // Find the governance root element
  const rootElement = document.getElementById('t24-governance-root');

  if (!rootElement) {
    console.warn('Trabajo24 Governance: Root element #t24-governance-root not found');
    return;
  }

  // Check if t24Governance config is available
  if (typeof window.t24Governance === 'undefined') {
    console.error('Trabajo24 Governance: window.t24Governance config not found');
    rootElement.innerHTML = '<div class="t24-error">Configuration error. Please refresh the page.</div>';
    return;
  }

  try {
    // Read configuration from data attributes
    const config = {
      view: rootElement.dataset.view || 'kanban',
      category: rootElement.dataset.category || '',
      showCreate: rootElement.dataset.showCreate === 'true',
      showVoting: rootElement.dataset.showVoting !== 'false',
      columns: rootElement.dataset.columns || 'pending,active,in-review,passed,rejected',
    };

    // Create React 18 root
    const root = createRoot(rootElement);

    // Render the governance dashboard
    root.render(<GovernanceDashboard config={config} />);

    console.log('Trabajo24 Governance: Dashboard initialized successfully');
  } catch (error) {
    console.error('Trabajo24 Governance: Failed to initialize dashboard', error);
    rootElement.innerHTML = `
      <div class="t24-error">
        <p>Failed to load governance dashboard.</p>
        <p style="font-size: 0.9em; color: rgba(255,255,255,0.6);">${error.message}</p>
      </div>
    `;
  }
}
